module.exports = __webpack_public_path__ + "static/media/washing-machine.a4a1ca06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/washing-machine.png
// module id = 1065
// module chunks = 0